export default {
  companyName: 'Company Name',
  company: 'Company | Companies',
  project: 'Project | Projects',
  license: 'License',
  firstName: 'Firstname',
  lastName: 'Lastname',
  email: 'E-Mail',
  phone: 'Phone',
  lastUpdated: 'Last updated',
  createdAt: 'Created at',
  validFrom: 'Valid from',
  validTo: 'Valid to',
  save: 'Save',
  create: 'Create',
  currency: 'Currency',
  street: 'Street',
  city: 'City',
  region: 'Region',
  country: 'Country',
  postalCode: 'Postal code',
  month: 'Month | Months',
  durationMonth: 'Duration Month | Duration Months',
  state: 'State',
  description: 'Description',
  displayName: 'Display name',
  contact: 'Contact',
  site: 'Site | Sites',
  module: 'Module | Modules',
  setting: 'Setting | Settings',
  type: 'Type',
  revisionId: 'Revision',
  createdAtUtc: 'Created at',
  createdBy: 'Created by',
  lastModifiedBy: 'Last modified by',
  lastModifiedAt: 'Last modified at',
  revisedAtUtc: 'Modified on',
  revisedBy: 'Modified by',
  revision: 'Revision',
  history: 'History',
  new: 'New',
  hasIndividualPurchase: 'Individual Purchased',
  hasSoftwareAgreement: 'Software Agreement',
  qmulusCloud: 'QMULUS Cloud',
  customerEnvironment: 'Customer Environment',
  deploymentType: 'Deployment Type',
  price: 'Price',
  comparePrice: 'Reduced Price',
  intercompanyComparePrice: 'Intercompany Price',
  assets: 'Assets',
  installation: 'Installation',
  quantityTypeI: 'Type I',
  quantityTypeIi: 'Type II',
  quantityTypeIii: 'Type III',
  quantityAutomatI: 'Automat I',
  quantityAutomatIi: 'Automat II',
  quantityAutomatIii: 'Automat III',
  quantityCars: 'Cars',
  quantityMagazines: 'Magazines',
  quantityTLines: 'T-Lines',
  monthly: 'Monthly',
  yearly: 'Yearly',
  customDuration: '{0} Months',
  summary: 'Summary',
  deploymentConfiguration: 'Deployment Configuration',
  discount: 'Discount: {0}',
  intercompanyDiscount: 'Intercompany: {0}',
  duration: 'Duration',
  requires: 'Requires: {0}',
  durationMonths: 'Duration (Months)',
};
